const COMPONENT_NAME = "TextBuilderCard";
const SHOW_BUTTON_ID = "textbuildercard-disclaimerdetails-show";
const HIDE_BUTTON_ID = "textbuildercard-disclaimerdetails-hide";
const TITLE_ID = "textbuildercard-title";
const TITLE = "title";
const SUBTITLE = "subtitle";
const BODY = "body";
const DISCLAIMER = "disclaimer";
const TITLE_V2 = "title_v2";
const SUBTITLE_V2 = "subtitle_v2";
const BODY_V2 = "body_v2";
const DISCLAIMER_V2 = "disclaimer_v2";
const MIN_HEIGHT_SIX_LINES_PX = 122;
const VISIBLE_LINES_CLAMP = 5;
const HEADING_V2 = "heading_v2";
const SUBHEADING_V2 = "subheading_v2";
const BODY_COPY_V2 = "body_copy_v2";
const SMALL_BODY_V2 = "body_copy_sm_v2";
const CAPTION_V2 = "caption_v2";
const TITLE_WITH_XL_V2 = "title_with_xl_v2";
const TEXT_TYPES = [
  TITLE,
  SUBTITLE,
  BODY,
  DISCLAIMER,
  TITLE_V2,
  SUBTITLE_V2,
  BODY_V2,
  DISCLAIMER_V2,
  HEADING_V2,
  SUBHEADING_V2,
  BODY_COPY_V2,
  CAPTION_V2,
  TITLE_WITH_XL_V2,
  SMALL_BODY_V2
];
export {
  BODY,
  BODY_COPY_V2,
  BODY_V2,
  CAPTION_V2,
  COMPONENT_NAME,
  DISCLAIMER,
  DISCLAIMER_V2,
  HEADING_V2,
  HIDE_BUTTON_ID,
  MIN_HEIGHT_SIX_LINES_PX,
  SHOW_BUTTON_ID,
  SMALL_BODY_V2,
  SUBHEADING_V2,
  SUBTITLE,
  SUBTITLE_V2,
  TEXT_TYPES,
  TITLE,
  TITLE_ID,
  TITLE_V2,
  TITLE_WITH_XL_V2,
  VISIBLE_LINES_CLAMP
};
